module.exports = __webpack_public_path__ + "img/empty-search.b5433619.svg";